import { VdTracking } from '@vend/vend.js'
import angular from 'angular'

import { $http } from '../../ng-compat/imports'
import { AutocompleteSource, SearchResult } from './autocomplete-source'

/**
 * A search index for searching products and customers via /api/2.0/suggest (backed by the typey microservice).
 *
 * @module typeySearchSource
 */
angular
  .module('webregister.factories')
  .factory('typeySearchSource', function (vdTracking: VdTracking) {
    const SUGGEST_URL = '/api/2.0/suggest?type=product&type=customer'

    function searchTypey(query: $TSFixMe) {
      const params = { q: query }
      return $http
        .get<{ data: SearchResult[] }>(SUGGEST_URL, { params })
        .then(response => {
          const responseData = response.data
          return responseData.data || []
        })
    }

    return new AutocompleteSource({
      name: 'typeySearchSource',
      types: ['product', 'customer'],
      search: searchTypey,
      vdTracking,
    })
  })
